import type {
  UserRequestStat,
  UserRequestStatScope,
} from '@pulpo/pulpo-models';

const ACTION_LABELS: Record<string, string> = {
  QuotedAvailability: 'List',
  Quote: 'Quote',
  Booking: 'Book',
  MinimalBooking: 'Book (minimal)',
};

/** Producers know the canals by their source, the admin by their protocol. */
const PRODUCER_CANAL_LABELS: Record<string, string> = {
  rest: 'PULPO',
  xml: 'ORCHESTRA',
};

export function requesterDisplayName(stat: UserRequestStat): string {
  const name = [stat.firstName, stat.lastName].filter(Boolean).join(' ');
  return name || stat.login || stat.requester || stat.userId || '';
}

export function canalLabel(scope: UserRequestStatScope, canal: string): string {
  return (scope === 'producer' && PRODUCER_CANAL_LABELS[canal]) || canal;
}

export function actionLabel(action: string): string {
  return ACTION_LABELS[action] || action;
}
